export const styles = {
  textField: {
    width: '100%',
  },
  closeIcon:{
    marginLeft: 'auto'
  }
};
